var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 7.94922C18.625 7.70508 18.5273 7.48047 18.332 7.29492L11.8574 0.839844C11.6426 0.625 11.4375 0.546875 11.2031 0.546875C10.7246 0.546875 10.3535 0.898438 10.3535 1.38672C10.3535 1.62109 10.4316 1.8457 10.5879 2.00195L12.7754 4.22852L16.0566 7.22656L13.7031 7.08008H1.34961C0.841797 7.08008 0.490234 7.44141 0.490234 7.94922C0.490234 8.45703 0.841797 8.81836 1.34961 8.81836H13.7031L16.0664 8.67188L12.7754 11.6699L10.5879 13.8965C10.4316 14.043 10.3535 14.2773 10.3535 14.5117C10.3535 15 10.7246 15.3516 11.2031 15.3516C11.4375 15.3516 11.6426 15.2637 11.8379 15.0781L18.332 8.60352C18.5273 8.41797 18.625 8.19336 18.625 7.94922Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b33c2af478c77a51ff2fc3af60e683f6.svg";
export { ForwardRef as ReactComponent };